import service from "@/services/user";
import serviceRepresentation from "@/services/representation";
import Cookies from "js-cookie";
import Vue from "vue";
import { PRIVILEGES } from "@/constants/privileges";
import { ROUTE_NAMES, ROUTES } from "@/constants/routeConstants";
import { i18n } from "@/plugins/i18n";

const user = {
  namespaced: true,

  state: {
    profile: {
      id: null,
      first_name: "",
      last_name: "",
      email: "",
      person_code: "",
      language: "",
      accept_time: null,
      phone: null,
      person_code_foreign: false,
    },
    userv4: {},
    roles: [],
    apartments: [],
    active_role: {},
    cooperatives: [],
    active_buildings: [],
    active_building_apartments: [],
    active_apartment: {},
    active_cooperative: {},
    userCooperatives: {},
    representation: {},
    userCooperativesLoading: false,
  },

  getters: {
    profile: (state) => state.profile,
    userv4: (state) => state.userv4,
    isProfileLoaded: (state) => !!state.profile.id,
    acceptTime: (state) => Boolean(state.profile.accept_time),
    privileges: (state) => state.active_role.privileges,
    roles: (state) => state.roles,
    active_role: (state) => state.active_role,
    activeRoleType: (state) => state.active_role.personType,
    active_apartment: (state) => state.active_apartment,
    active_cooperative: (state) => state.active_cooperative,
    active_cooperativeGroups: (state) => state.active_cooperative.groups,
    cooperatives: (state) => state.cooperatives,
    userCooperatives: (state) => state.userCooperatives,
    representation: (state) => state.representation,
    userCooperativesLoading: (state) => state.userCooperativesLoading,
    apartments: (state) => {
      return state.apartments;
    },
    cooperativeName: (state) => (id) => {
      if (!id) {
        return "";
      }
      return state.cooperatives.find((coop) => coop.id === id)?.name;
    },
    getProfileDataSet: (state) => {
      return {
        id: state.profile.id,
        first_name: state.profile.first_name,
        last_name: state.profile.last_name,
        company_name: state.profile.companyName,
      };
    },
    cooperative: (state) => (id) => {
      if (!id) {
        return "";
      }
      return state.cooperatives.find((coop) => coop.id === id);
    },
    correctRoleType: (state) => (type) => {
      if (!type) {
        return false;
      }
      return type.includes(state.active_role.personType);
    },
    getCooperativeIdByName: (state) => (name) => {
      if (!name) {
        return null;
      }
      return state.cooperatives.find((coop) => coop.name === name).id;
    },
    getApartmentsByCooperativeId: (state) => (id) => {
      if (!id) {
        return null;
      }
      return state.apartments.filter((ap) => ap.cooperative_id === id);
    },
    getCooperativeByCountyId: (state) => (id) => {
      if (!id) return [];
      return state.cooperatives.filter((coop) => coop.county.id === Number(id));
    },
  },

  mutations: {
    profile(state, profile) {
      state.profile = profile;
    },
    userv4(state, userv4) {
      state.userv4 = userv4;
    },
    representation(state, representation) {
      state.representation = representation;
    },
    roles(state, roles) {
      state.roles = roles;
    },
    apartments(state, apartments) {
      state.apartments = apartments;
    },
    active_role(state, active_role) {
      state.active_role = active_role;
    },
    active_apartment(state, active_apartment) {
      state.active_apartment = active_apartment;
      if (Cookies.get("Cookies")) {
        if (Cookies.get("CoopApartment")) {
          Cookies.set("CoopApartment", [
            state.active_cooperative.id,
            active_apartment.id,
          ]);
        }
      }
    },
    active_cooperative(state, active_cooperative) {
      state.active_cooperative = active_cooperative;
      const apartments = state.apartments.filter(
        (ap) => ap.cooperative_id === state.active_cooperative.id
      );
      state.active_apartment = apartments[0];
      if (Cookies.get("Cookies")) {
        if (Cookies.get("CoopApartment")) {
          if (apartments && apartments.length) {
            Cookies.set("CoopApartment", [
              state.active_cooperative.id,
              apartments[0].id,
            ]);
          } else {
            Cookies.set("CoopApartment", [state.active_cooperative.id]);
          }
        }
      }
    },
    cooperatives(state, cooperatives) {
      state.cooperatives = cooperatives.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },
    setUserCooperatives(state, data) {
      let falsyCooperatives = 0;
      data.cooperatives = data.cooperatives.filter((x) => {
        if (x) {
          return x;
        } else {
          falsyCooperatives += 1;
        }
      });
      data.count = data.count - falsyCooperatives;
      state.userCooperatives = data;
    },
    setUserCooperativesLoading(state, loading) {
      state.userCooperativesLoading = loading;
    },
    setActiveCoopAndApartment(state) {
      if (state.active_role.personType !== "kvatro") {
        if (Cookies.get("Cookies")) {
          if (Cookies.get("CoopApartment")) {
            const [coop1, apart] = Cookies.get("CoopApartment").split(",");

            state.active_cooperative = state.cooperatives.find(
              (coop) => coop.id === parseInt(coop1)
            );
            state.active_apartment = state.apartments.find(
              (ap) => ap.id === parseInt(apart)
            );
          } else {
            state.active_cooperative = state.cooperatives[0];

            const apartments = state.apartments.filter(
              (ap) => ap.cooperative_id === state.active_cooperative.id
            );
            state.active_apartment = apartments[0];
            if (apartments && apartments.length) {
              Cookies.set("CoopApartment", [
                state.active_cooperative.id,
                apartments[0].id,
              ]);
            } else {
              Cookies.set("CoopApartment", [state.active_cooperative.id]);
            }
          }
        } else {
          state.active_cooperative = state.cooperatives[0];

          const apartments = state.apartments.filter(
            (ap) => ap.cooperative_id === state.active_cooperative.id
          );

          state.active_apartment = apartments[0];
        }
      } else if (state.cooperatives && state.cooperatives.length) {
        // state.active_cooperative = state.cooperatives[0];
      }
    },
  },

  actions: {
    async changeRole({ dispatch, commit }, new_role) {
      try {
        await service.changeRole(new_role);
        commit("meeting/clearMeeting", null, { root: true });
        Cookies.remove("CoopApartment");
        await dispatch("fetch");
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async findCooperativeById({ commit, state }, id) {
      try {
        const cooperative = state.cooperatives.find(
          (coop) => coop.id === Number(id)
        );
        if (cooperative) {
          commit("active_cooperative", cooperative);
          return Promise.resolve();
        }
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async changeLang({ commit }, lang) {
      try {
        await service.changeLang(lang);
      } catch (err) {
        commit("error", err);
      }
    },
    async termsAcceptTime({ commit, state }) {
      try {
        const { data } = await service.getOnBoarding();
        const { termsAccepted } = data;

        if (termsAccepted === undefined && window.location.href.indexOf(ROUTES.onBoarding) === -1) {
          window.location.href = '/et/' + ROUTES.onBoarding;
        }
        commit("profile", {
          ...state.profile,
          accept_time: termsAccepted,
        });
      } catch (e) {
        console.error(e);
      }
    },
    async fetch({ dispatch, commit }, roleUpdate = false) {
      try {
        const { data } = await service.fetchUser();
        const {
          companyName,
          juridicialAddress,
          personType,
          bankAccount,
          firstName: first_name,
          lastName: last_name,
          email,
          personCode: person_code,
          personCodeForeign: person_code_foreign,
          phone,
          language,
          roles,
          activeRole: { role: active_role },
          cooperatives,
          id,
        } = data;

        if (id) {
          //this is required for XSRF-TOKEN
          await service.apiv4UserBySession();

          //commit("userv4", userv4Data);

          const sessionData = await service.apiv4Session();
          commit("userv4", sessionData);

          const representationData = await serviceRepresentation.representation(
            {
              userId:
                sessionData.primary_user?.id !== undefined
                  ? sessionData.primary_user.id
                  : id,
            }
          );
          commit("representation", representationData);
        }

        commit("roles", roles);
        if (roleUpdate) {
          dispatch("getUserCooperatives", active_role.id);
          return;
        }

        const apartments = [];
        cooperatives.forEach((coop) => {
          coop.groups.forEach((group) => {
            if (group.apartments.length) {
              group.apartments.forEach((apartment) => {
                const obj = {
                  id: apartment.id,
                  name: apartment.name,
                  cooperative_id: coop.id,
                  cooperative_name: coop.name,
                  ...(group.apartments.length > 1 && {
                    groupAddress: group.address,
                  }),
                };
                apartments.push(obj);
              });
            }
          });
        });

        commit("profile", {
          id,
          first_name,
          last_name,
          email,
          person_code,
          language,
          phone,
          person_code_foreign,
          companyName,
          juridicialAddress,
          personType,
          bankAccount,
        });
        commit("apartments", apartments);
        commit("active_role", active_role);
        commit("cooperatives", cooperatives);
        commit("setActiveCoopAndApartment");
        await dispatch("termsAcceptTime");
        if (!roleUpdate) dispatch("getUserCooperatives", active_role.id);
      } catch (err) {
        console.error(err);
        commit("error", err);
      }
    },
    async getUserCooperatives({ commit }, id) {
      if (Vue.prototype.$privilege(PRIVILEGES.haldusnet.view)) {
        try {
          commit("setUserCooperativesLoading", true);
          const data = await service.getUserCooperatives(id);
          commit("setUserCooperatives", data);
        } catch (error) {
          console.error(error);
        } finally {
          commit("setUserCooperativesLoading", false);
        }
      }
    },
  },
};

export default user;
